var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"containerLeft"}},[(_vm.getGameConsole === 'default')?_c('v-card',{staticClass:"card_tree_left"},[(
        this.getLiveMode == 'preview' ||
        _vm.checkIsMobile() ||
        _vm.checkIsTablet() ||
        !_vm.getSettings.enableLive
      )?_c('tree'):(_vm.getSettings.enableLive)?_c('LiveEventsVerticalScroller'):_vm._e()],1):_vm._e(),(_vm.getGameConsole === 'marketview')?_c('v-card',{staticClass:"card_tree_left_v2"},[(
        this.getLiveMode == 'preview' ||
        _vm.checkIsMobile() ||
        _vm.checkIsTablet() ||
        !_vm.getSettings.enableLive
      )?_c('tree-v2'):(_vm.getSettings.enableLive)?_c('LiveEventsVerticalScroller'):_vm._e()],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }